import React from 'react';
import { ShieldCheck, Users, Search, Map, Truck } from 'lucide-react';
const TRUST_ITEMS = [{
  icon: ShieldCheck,
  title: '22+ years of industry experience',
  subtext: 'Residential, commercial, and streetscape products.'
}, {
  icon: Users,
  title: 'Family-owned & woman-owned',
  subtext: 'A real team you can call before ordering.'
}, {
  icon: Search,
  title: 'Free diagnostic & estimating help',
  subtext: 'Send photos for model, part, or replacement guidance.'
}, {
  icon: Map,
  title: 'USPS-aware project guidance',
  subtext: 'Helpful for CBUs, 4C systems, parcel lockers, and replacements.'
}, {
  icon: Truck,
  title: 'Nationwide shipping + select-area installation',
  subtext: 'Installation available in MD, VA, DC, PA, and WV.'
}];
export function TrustRail() {
  return <section aria-label="Why shop with MidAtlantic" className="bg-white border-b border-brand-border pt-8 pb-12 lg:pt-10 lg:pb-14 relative z-20" data-id="element-461">
      <div className="max-w-7xl mx-auto px-4" data-id="element-462">
        <div className="text-center mb-8" data-id="element-463">
          <span className="text-brand-maroon font-bold tracking-wider uppercase text-xs flex items-center justify-center gap-2" data-id="element-464">
            <span className="w-8 h-px bg-brand-gold" data-id="element-465"></span>
            Why shop with MidAtlantic
            <span className="w-8 h-px bg-brand-gold" data-id="element-466"></span>
          </span>
          <h2 className="text-xl lg:text-2xl font-serif font-bold text-brand-charcoal mt-2" data-id="element-467">
            Expertise and support behind every order
          </h2>
        </div>

        {/* Mobile: horizontal scroll, Desktop: grid */}
        <div className="flex overflow-x-auto pb-4 lg:pb-0 lg:grid lg:grid-cols-5 gap-4 lg:gap-6 snap-x snap-mandatory hide-scrollbar" data-id="element-468">
          {TRUST_ITEMS.map((item, idx) => {
          const Icon = item.icon;
          return <div key={idx} className="flex-shrink-0 w-72 lg:w-auto snap-start flex flex-col items-start gap-3 p-4 rounded-lg bg-white border border-brand-border hover:border-brand-gold transition-colors" data-id="element-469">
                <div className="w-10 h-10 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center shrink-0" data-id="element-470">
                  <Icon size={20} strokeWidth={1.5} data-id="element-471" />
                </div>
                <div data-id="element-472">
                  <h4 className="font-bold text-brand-charcoal text-sm mb-1 leading-tight" data-id="element-473">
                    {item.title}
                  </h4>
                  <p className="text-xs text-brand-muted leading-relaxed" data-id="element-474">
                    {item.subtext}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}